import React, { useCallback, useEffect, useState } from 'react';
import { Wrapper } from './styles';
import { Menu } from '../../../components/Menu';
import { usePages } from '../../../hooks/Pages';
import FooterLayout from '../../Footer';
import { useAuth } from '../../../hooks/Auth';
import PopupComponent from '../../../components/PopupContainer';

import Particles from 'react-particles-js';
import ImageSliderBackground from '../../../components/ImageBackgroundSlider';
import { useParams } from 'react-router-dom';
import { useConfiguration } from '../../../hooks/Configuration';
import api from '../../../services/api';
import Loader from '../../DashboardPages/core/components/Loader';
import { urlWebsite } from '../../../config';
import { useSocket } from '../../../hooks/Socket';
import { useVideo } from '../../../hooks/Video';

interface IParams {
  projectHash: string;
  eventHash: string;
}


const DefaultLayout: React.FC = ({ children }) => {
  const page = window.location.pathname !== '/';
  const { menu, setMenu, prepareMenu } = usePages();

  const { token, user, handleApiErrors } = useAuth();
  const { configuration, setConfiguration } = useConfiguration();

  const [loading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);



  const { projectHash, eventHash } = useParams<IParams>();


  const load = async () => {
    // setLoading(true);

    try {
      const response = await api.get(eventHash ? `/get-project-content/${projectHash}/${eventHash}` : `/get-project-content/${projectHash}`);

      setConfiguration(response.data);



      if (response?.data?.active_pages?.length > 0) {

        prepareMenu({ eventHash, projectHash, active_pages: response?.data?.active_pages });
      }



      setLoading(false);
      setReady(true);

    }
    catch (err) {

      handleApiErrors(err);
      setLoading(false);
    }
  }


  useEffect(() => {
    if (projectHash) {
      load();
      window.scrollTo(0, 0);
    }
    else {
      setLoading(false);
      setReady(true);
      setConfiguration({});
      setMenu([
        {
          title: 'Home',
          target: '/',
          targetID: '/',
          fluid: 1,
          external: 1,
          status: 2,
        }
      ]);
    }
  }, [projectHash, eventHash])




  return (
    <>
      {loading && <Loader message='Carregando' />}
      <Wrapper background_color={configuration.background_color} background={`${urlWebsite}/${configuration.background}`}>

        <Menu menuList={menu} fixedMenu={false} />
        {ready && <>
          {children}

          <PopupComponent />


        </>}
      </Wrapper>
      <FooterLayout />
      {configuration?.fixed_image_header && <img src={`${urlWebsite}/${configuration.fixed_image_header}`} className="fixedBottom" />}
    </>
  );
};

export default DefaultLayout;
